<template>
    <div class="main">
        <c-panel title="QUADRO DE HORÁRIOS" titleIcon="fas fa-table">

            <el-form label-position="top" @submit.native.prevent>
                <el-row :gutter="10" class="u-mb-15">
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Escola" class="u-mb-0">
                            <el-select v-model="instituicaoId" filterable style="width: 100%;" @change="carregarTurmas">
                                <el-option v-for="i in instituicoes" :key="i.id" :value="i.id" :label="i.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6">
                        <el-form-item label="Período letivo" class="u-mb-0">
                            <el-select v-model="periodoId" style="width: 100%;" @change="carregarTurmas">
                                <el-option v-for="p in periodos" :key="p.id" :value="p.id" :label="p.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="10">
                        <el-form-item label="Turma" class="u-mb-0">
                            <el-select v-model="turmaId" filterable placeholder="Selecione a turma" style="width: 100%;" @change="carregarTudo">
                                <el-option v-for="t in turmas" :key="t.id" :value="t.id" :label="rotuloTurma(t)"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>

            <div v-if="!turmaId" class="u-text-center u-mt-25">Selecione uma turma para ver o quadro.</div>

            <el-tabs v-else v-model="aba">

                <!-- ==================== GRADE ==================== -->
                <el-tab-pane label="Grade" name="grade">

                    <el-alert v-if="config && config.aviso" type="warning" :closable="false" class="u-mb-15" :title="config.aviso"></el-alert>

                    <el-alert v-if="config && config.origem === 'legado'" type="info" :closable="false" class="u-mb-15"
                        title="Esta turma não tem configuração de horários. A grade abaixo segue o comportamento atual do sistema: segunda a sexta, sem hora definida."></el-alert>

                    <div class="u-mb-10 u-text-right">
                        <el-button plain icon="el-icon-printer" :disabled="!slots.length" @click="imprimir">IMPRIMIR QUADRO</el-button>
                    </div>

                    <div v-if="config" class="u-mb-10">
                        <small>
                            Dias efetivos: <strong>{{ nomesDias(config.dias_efetivos) }}</strong>
                            · Origem da configuração: <strong>{{ config.origem }}</strong>
                            <span v-if="config.configuracao_nome"> ({{ config.configuracao_nome }})</span>
                        </small>
                    </div>

                    <div class="container-table">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th style="width: 90px;">Ordem</th>
                                    <th style="width: 130px;">Horário</th>
                                    <th v-for="d in diasGrade" :key="'h' + d">{{ nomeDoDia[d] }}</th>
                                </tr>
                            </thead>
                            <tbody v-if="statusQuadro">
                                <tr v-for="linha in linhasGrade" :key="'o' + linha.ordem">
                                    <td>{{ linha.ordem }}º</td>
                                    <td><small>{{ linha.horario || '—' }}</small></td>
                                    <td v-for="d in diasGrade" :key="'c' + d + '-' + linha.ordem">
                                        <div v-for="s in slotsDe(d, linha.ordem)" :key="s.id" class="u-mb-5">
                                            <strong>{{ s.area_conhecimento ? s.area_conhecimento.nome_area : (s.marcador_legado || '—') }}</strong>
                                            <div v-if="s.servidor"><small>{{ s.servidor.nome }}</small></div>
                                            <div v-if="s.divisao"><small><em>{{ s.divisao.nome }}</em></small></div>
                                            <div v-if="s.dependencia"><small>{{ s.dependencia.nome }}</small></div>
                                            <el-button v-if="podeEscrever" @click="removerSlot(s.id)" title="Remover aula"
                                                       type="danger" icon="el-icon-delete" size="mini" plain class="u-mt-5"></el-button>
                                        </div>
                                        <span v-if="!slotsDe(d, linha.ordem).length">—</span>
                                    </td>
                                </tr>
                                <tr v-if="!linhasGrade.length">
                                    <td :colspan="diasGrade.length + 2" class="u-text-center">
                                        Turma sem quadro relacional. O comportamento continua sendo o atual.
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div v-if="!statusQuadro" class="u-text-center u-mt-25"><img src="/public/img/loading-bar.gif" /></div>
                    </div>

                    <div v-if="intervalos.length" class="u-mt-10">
                        <small>Intervalos (não recebem aula): {{ intervalos.join(' · ') }}</small>
                    </div>
                </el-tab-pane>

                <!-- ==================== GERAÇÃO ==================== -->
                <el-tab-pane label="Geração automática" name="gerar">

                    <el-alert type="info" :closable="false" class="u-mb-15"
                        title="A prévia é apenas uma simulação: nada é gravado enquanto você não aplicar. A aplicação recalcula tudo no servidor antes de gravar."></el-alert>

                    <div class="u-mb-15">
                        <el-button type="primary" plain icon="el-icon-view" @click="gerarPrevia">1 · GERAR PRÉVIA</el-button>
                        <el-button class="u-ml-10" v-if="podeEscrever" type="success" icon="el-icon-check"
                                   :disabled="!previaAplicavel" @click="aplicar">2 · APLICAR QUADRO</el-button>
                        <small v-if="previa && !previaAplicavel" class="u-ml-10">
                            A aplicação só fica disponível quando o servidor classificar a turma como totalmente gerável.
                        </small>
                    </div>

                    <div v-if="previa">
                        <el-alert :type="tipoStatus(previa.status)" :closable="false" class="u-mb-15"
                                  :title="rotuloStatus(previa.status) + (previa.motivo ? ' — ' + previa.motivo : '')"></el-alert>

                        <el-row :gutter="10" class="u-mb-15" v-if="previa.totais">
                            <el-col :xs="8"><div class="u-text-center"><h3 class="u-mb-0">{{ previa.totais.carga_requerida }}</h3><small>carga requerida</small></div></el-col>
                            <el-col :xs="8"><div class="u-text-center"><h3 class="u-mb-0">{{ previa.totais.carga_alocada }}</h3><small>carga alocada</small></div></el-col>
                            <el-col :xs="8"><div class="u-text-center"><h3 class="u-mb-0">{{ previa.totais.carga_nao_alocada }}</h3><small>não alocada</small></div></el-col>
                        </el-row>

                        <h4 v-if="previa.componentes && previa.componentes.length">Componentes</h4>
                        <div class="container-table" v-if="previa.componentes && previa.componentes.length">
                            <table class="table table-striped">
                                <thead><tr><th>Componente</th><th>Requerida</th><th>Alocada</th><th>Não alocada</th></tr></thead>
                                <tbody>
                                    <tr v-for="c in previa.componentes" :key="'c' + c.matriz_etapa_componente_id">
                                        <td>{{ c.componente }}</td>
                                        <td>{{ c.carga_requerida }}</td>
                                        <td>{{ c.carga_alocada }}</td>
                                        <td>{{ c.carga_nao_alocada }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <h4 v-if="previa.slots_propostos && previa.slots_propostos.length" class="u-mt-15">Aulas propostas</h4>
                        <div class="container-table" v-if="previa.slots_propostos && previa.slots_propostos.length">
                            <table class="table table-striped">
                                <thead><tr><th>Dia</th><th>Ordem</th><th>Horário</th><th>Componente</th></tr></thead>
                                <tbody>
                                    <tr v-for="(s, i) in previa.slots_propostos" :key="'p' + i">
                                        <td>{{ nomeDoDia[s.dia_semana] }}</td>
                                        <td>{{ s.ordem_aula }}º</td>
                                        <td><small>{{ s.hora_inicio || '—' }} {{ s.hora_fim ? '– ' + s.hora_fim : '' }}</small></td>
                                        <td>{{ s.componente }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <h4 v-if="previa.nao_alocados && previa.nao_alocados.length" class="u-mt-15">Não alocados</h4>
                        <el-alert v-for="(n, i) in previa.nao_alocados" :key="'n' + i" type="warning" :closable="false" class="u-mb-5"
                                  :title="(n.componente || 'Componente') + ' — ' + n.motivo"></el-alert>

                        <h4 v-if="previa.conflitos && previa.conflitos.length" class="u-mt-15">Conflitos</h4>
                        <el-alert v-for="(c, i) in previa.conflitos" :key="'x' + i" type="error" :closable="false" class="u-mb-5" :title="c.mensagem"></el-alert>

                        <h4 v-if="previa.indeterminados && previa.indeterminados.length" class="u-mt-15">Indeterminados</h4>
                        <el-alert v-for="(c, i) in previa.indeterminados" :key="'ind' + i" type="info" :closable="false" class="u-mb-5" :title="c.mensagem"></el-alert>

                        <h4 v-if="previa.avisos && previa.avisos.length" class="u-mt-15">Avisos</h4>
                        <el-alert v-for="(c, i) in previa.avisos" :key="'a' + i" type="info" :closable="false" class="u-mb-5" :title="c.mensagem"></el-alert>
                    </div>
                </el-tab-pane>

                <!-- ==================== CONFLITOS ==================== -->
                <el-tab-pane label="Conflitos" name="conflitos">
                    <el-button plain icon="el-icon-search" @click="diagnosticarConflitos">DIAGNOSTICAR</el-button>

                    <div v-if="conflitos" class="u-mt-15">
                        <el-alert :type="conflitos.severidade === 'conflito' ? 'error' : (conflitos.severidade === 'aviso' ? 'warning' : 'success')"
                                  :closable="false" class="u-mb-15"
                                  :title="'Situação: ' + conflitos.severidade + ' · ' + (conflitos.total_conflitos || 0) + ' conflito(s), ' + (conflitos.total_avisos || 0) + ' aviso(s)'"></el-alert>
                        <el-alert v-if="conflitos.aviso" type="info" :closable="false" class="u-mb-15" :title="conflitos.aviso"></el-alert>
                        <el-alert v-for="(a, i) in (conflitos.achados || [])" :key="'ac' + i"
                                  :type="a.severidade === 'conflito' ? 'error' : 'warning'" :closable="false" class="u-mb-5"
                                  :title="nomeDoDia[a.dia_semana] + ', ' + a.ordem_aula + 'º horário — ' + a.mensagem"></el-alert>
                    </div>
                </el-tab-pane>

                <!-- ==================== DEPENDÊNCIAS ==================== -->
                <el-tab-pane label="Dependências" name="dependencias">

                    <el-alert type="info" :closable="false" class="u-mb-15"
                        title="O cadastro registra TIPOS de dependência (sala de aula, quadra, laboratório), não salas identificáveis. Por isso duas turmas usando o mesmo tipo no mesmo horário não constituem conflito."></el-alert>

                    <el-alert v-if="depInit && depInit.aviso" type="warning" :closable="false" class="u-mb-15" :title="depInit.aviso"></el-alert>

                    <el-row v-if="podeEscrever && depInit" :gutter="10" class="u-mb-15">
                        <el-col :xs="24" :sm="10">
                            <el-select v-model="novaDep.dependencia_instituicao_id" filterable placeholder="Tipo de dependência" style="width: 100%;">
                                <el-option v-for="d in (depInit.dependencias || [])" :key="d.id" :value="d.id" :label="d.nome"></el-option>
                            </el-select>
                        </el-col>
                        <el-col :xs="24" :sm="8">
                            <el-input v-model="novaDep.finalidade" placeholder="Finalidade (opcional)" maxlength="100"></el-input>
                        </el-col>
                        <el-col :xs="12" :sm="3"><el-checkbox v-model="novaDep.principal">Principal</el-checkbox></el-col>
                        <el-col :xs="12" :sm="3" class="u-text-right"><el-button type="primary" @click="salvarDependencia">ADICIONAR</el-button></el-col>
                    </el-row>

                    <div class="container-table">
                        <table class="table table-striped">
                            <thead><tr><th>Tipo de dependência</th><th>Finalidade</th><th class="u-text-center">Principal</th><th style="width: 90px;" class="u-text-center">Ação</th></tr></thead>
                            <tbody>
                                <tr v-for="d in dependencias" :key="d.id">
                                    <td>{{ d.dependencia ? d.dependencia.nome : d.dependencia_instituicao_id }}</td>
                                    <td>{{ d.finalidade || '—' }}</td>
                                    <td class="u-text-center">{{ d.principal ? 'Sim' : '—' }}</td>
                                    <td class="u-text-center">
                                        <el-button v-if="podeEscrever" @click="excluirDependencia(d.id)" title="Remover" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
                                        <span v-if="!podeEscrever">—</span>
                                    </td>
                                </tr>
                                <tr v-if="!dependencias.length"><td colspan="4" class="u-text-center">Nenhuma dependência vinculada.</td></tr>
                            </tbody>
                        </table>
                    </div>
                </el-tab-pane>

                <!-- ==================== DIVISÕES ==================== -->
                <el-tab-pane label="Divisões" name="divisoes">

                    <el-alert type="info" :closable="false" class="u-mb-15"
                        title="A divisão organiza quem assiste a qual aula. Um aluno não pode estar em duas divisões do mesmo componente."></el-alert>

                    <el-button v-if="podeEscrever" type="primary" class="u-mb-15" @click="abrirNovaDivisao">NOVA DIVISÃO</el-button>

                    <div class="container-table">
                        <table class="table table-striped">
                            <thead><tr><th>Divisão</th><th>Componente</th><th>Professor</th><th class="u-text-center">Alunos</th><th class="u-text-center">No quadro</th><th style="width: 140px;" class="u-text-center">Ação</th></tr></thead>
                            <tbody>
                                <tr v-for="d in divisoes" :key="d.id">
                                    <td>{{ d.nome }}</td>
                                    <td>{{ d.area_conhecimento ? d.area_conhecimento.nome_area : d.area_conhecimento_id }}</td>
                                    <td>{{ d.servidor ? d.servidor.nome : '—' }}</td>
                                    <td class="u-text-center">{{ d.qtd_alunos }}</td>
                                    <td class="u-text-center">{{ d.em_uso_no_quadro ? d.em_uso_no_quadro + ' aula(s)' : '—' }}</td>
                                    <td class="u-text-center acao">
                                        <el-button v-if="podeEscrever" @click="abrirAlunos(d)" title="Alunos" type="info" icon="el-icon-user" size="mini" plain></el-button>
                                        <el-button class="u-ml-10" v-if="podeEscrever" @click="excluirDivisao(d.id)" title="Excluir" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
                                        <span v-if="!podeEscrever">—</span>
                                    </td>
                                </tr>
                                <tr v-if="!divisoes.length"><td colspan="6" class="u-text-center">Nenhuma divisão cadastrada.</td></tr>
                            </tbody>
                        </table>
                    </div>
                </el-tab-pane>
            </el-tabs>

            <!-- diálogo: nova divisão -->
            <el-dialog title="Nova divisão de componente" :visible.sync="dialogoDivisao" width="560px">
                <el-form label-position="top">
                    <el-form-item label="Componente">
                        <el-select v-model="novaDivisao.area_conhecimento_id" filterable style="width: 100%;" @change="carregarProfessoresValidos">
                            <el-option v-for="a in areas" :key="a.id" :value="a.id" :label="a.nome_area"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Nome da divisão">
                        <el-input v-model="novaDivisao.nome" maxlength="60" placeholder="Ex.: Grupo A"></el-input>
                    </el-form-item>
                    <el-form-item label="Professor">
                        <el-select v-model="novaDivisao.servidor_id" clearable style="width: 100%;" :disabled="!novaDivisao.area_conhecimento_id">
                            <el-option v-for="s in professoresValidos" :key="s.id" :value="s.id" :label="s.nome"></el-option>
                        </el-select>
                        <small v-if="avisoProfessores">{{ avisoProfessores }}</small>
                        <small v-else>Somente professores com vínculo acadêmico neste componente e turma.</small>
                    </el-form-item>
                    <el-form-item label="Máximo de alunos (opcional)">
                        <el-input v-model="novaDivisao.qtd_max_alunos" v-mask="'###'"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer">
                    <el-button @click="dialogoDivisao = false">CANCELAR</el-button>
                    <el-button class="u-ml-10" type="primary" @click="salvarDivisao">SALVAR</el-button>
                </span>
            </el-dialog>

            <!-- diálogo: alunos da divisão -->
            <el-dialog :title="'Alunos — ' + (divisaoAtual ? divisaoAtual.nome : '')" :visible.sync="dialogoAlunos" width="640px">
                <el-alert type="info" :closable="false" class="u-mb-15"
                    title="A lista traz apenas as matrículas desta turma que ainda não estão em outra divisão do mesmo componente."></el-alert>

                <el-transfer v-model="alunosSelecionados" :data="alunosOpcoes" :titles="['Disponíveis', 'Nesta divisão']" filterable
                             :props="{ key: 'key', label: 'label' }" style="width: 100%;"></el-transfer>

                <span slot="footer">
                    <el-button @click="dialogoAlunos = false">CANCELAR</el-button>
                    <el-button class="u-ml-10" type="primary" @click="salvarAlunos">SALVAR</el-button>
                </span>
            </el-dialog>
        </c-panel>
    </div>
</template>
<script>
/**
 * BLOCO F — itens 93, 97, 98, 103 e 104 do edital (Timbé do Sul/SC). Fase F10.
 *
 * Interface única por turma para `api/quadro-horario`, `api/gerador-quadro`,
 * `api/conflito-quadro`, `api/dependencia-turma` e `api/componente-divisao`.
 *
 * ==================== O BACKEND É A AUTORIDADE ====================
 *
 * Nada aqui recalcula grade, disponibilidade, carga, conflito, professor ou exclusividade
 * de aluno. As listas de opções vêm sempre da API (`initForm` das dependências,
 * `professoresValidos`, `alunosDisponiveis`), e as mensagens de erro são exibidas como
 * vieram, sem virar texto genérico.
 *
 * ==================== PRÉVIA ≠ GRAVAÇÃO ====================
 *
 * "1 · GERAR PRÉVIA" e "2 · APLICAR QUADRO" são visualmente distintos. A aplicação só é
 * habilitada quando o backend classificar a turma como `totalmente_geravel` — e isso é UX,
 * não segurança: a API revalida tudo de qualquer forma.
 *
 * `slots_propostos` NUNCA é enviado de volta: `aplicar` recebe apenas ids de turma.
 *
 * Nenhuma tela escreve em `parametros_diario.horarios_aulas`. A edição manual usa
 * exclusivamente as rotas da F9.
 */
import { periodosLetivosMixin } from '@/shared/periodos-letivos'
export default {
    mixins: [periodosLetivosMixin],
    data: () => ({
        aba: 'grade',
        instituicaoId: null,
        turmaId: null,
        periodoId: null,
        instituicoes: [],
        turmas: [],
        statusQuadro: false,
        config: null,
        quadro: null,
        previa: null,
        conflitos: null,
        dependencias: [],
        depInit: null,
        novaDep: { dependencia_instituicao_id: null, finalidade: '', principal: false },
        divisoes: [],
        areas: [],
        professoresValidos: [],
        avisoProfessores: null,
        dialogoDivisao: false,
        novaDivisao: { area_conhecimento_id: null, nome: '', servidor_id: null, qtd_max_alunos: '' },
        dialogoAlunos: false,
        divisaoAtual: null,
        alunosOpcoes: [],
        alunosSelecionados: [],
        nomeDoDia: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado']
    }),
    computed: {
        podeEscrever () {
            return [0, 1, 3, 4, 5, 6, 7, 9, 12].includes(parseInt(this.$store.state.user.tipo))
        },
        // Só o contrato do backend habilita a aplicação.
        previaAplicavel () {
            return !!this.previa && this.previa.status === 'totalmente_geravel'
                && this.previa.quadro_existente && this.previa.quadro_existente.estado === 'sem_quadro'
        },
        diasGrade () {
            if (this.config && Array.isArray(this.config.dias_efetivos) && this.config.dias_efetivos.length) {
                return this.config.dias_efetivos.map(d => parseInt(d))
            }
            return [1, 2, 3, 4, 5]
        },
        // Ordens vindas da configuração; sem ela, as ordens presentes no próprio quadro.
        linhasGrade () {
            const mapa = {}
            if (this.config && this.config.aulas) {
                Object.keys(this.config.aulas).forEach(dia => {
                    (this.config.aulas[dia] || []).forEach(l => {
                        if (l.tipo !== 'aula') return
                        const o = parseInt(l.ordem)
                        if (!mapa[o]) mapa[o] = { ordem: o, horario: (l.hora_inicio || '') + (l.hora_fim ? ' – ' + l.hora_fim : '') }
                    })
                })
            }
            ;(this.slots || []).forEach(s => {
                const o = parseInt(s.ordem_aula)
                if (!mapa[o]) mapa[o] = { ordem: o, horario: '' }
            })
            return Object.keys(mapa).map(k => mapa[k]).sort((a, b) => a.ordem - b.ordem)
        },
        // Intervalo ocupa horário e nunca vira aula.
        intervalos () {
            const r = []
            if (this.config && this.config.aulas) {
                Object.keys(this.config.aulas).forEach(dia => {
                    (this.config.aulas[dia] || []).forEach(l => {
                        if (l.tipo !== 'intervalo') return
                        const txt = (l.hora_inicio || '') + (l.hora_fim ? ' – ' + l.hora_fim : '')
                        if (txt && r.indexOf(txt) === -1) r.push(txt)
                    })
                })
            }
            return r
        },
        slots () { return (this.quadro && Array.isArray(this.quadro.slots)) ? this.quadro.slots : [] }
    },
    mounted () {
        this.periodoId = this.$store.state.config.periodo ? this.$store.state.config.periodo.id : null

        const inst = this.$store.state.config.instituicao
        if (inst && inst.id) {
            this.instituicoes = [inst]
            this.instituicaoId = inst.id
            this.carregarTurmas()
        } else {
            // Perfis de rede não têm instituição fixada no store.
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/instituicao/getAll`,
                this.$store.getters.getHeaderAuth
            ).then(r => { this.instituicoes = Array.isArray(r.data) ? r.data : [] }).catch(() => {})
        }
    },
    methods: {
        rotuloTurma (t) { return t.nome + (t.curso ? ' — ' + t.curso.nome : '') },
        nomesDias (dias) {
            if (!Array.isArray(dias) || !dias.length) return '—'
            return dias.map(d => this.nomeDoDia[parseInt(d)]).join(', ')
        },
        carregarTurmas () {
            this.turmaId = null
            this.turmas = []
            this.quadro = null
            this.config = null
            if (!this.instituicaoId || !this.periodoId) return
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/turma/getAllTurmas/${this.instituicaoId}/${this.periodoId}`,
                this.$store.getters.getHeaderAuth
            ).then(r => { this.turmas = Array.isArray(r.data) ? r.data : Object.values(r.data || {}).flat() }).catch(e => this.$store.commit('throwException', e))
        },
        carregarTudo () {
            if (!this.turmaId || !this.periodoId) return
            this.previa = null
            this.conflitos = null
            this.carregarConfig()
            this.carregarQuadro()
            this.carregarDependencias()
            this.carregarDivisoes()
        },
        carregarConfig () {
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/configuracao-horario/getEfetiva/${this.turmaId}`,
                this.$store.getters.getHeaderAuth
            ).then(r => { this.config = (r.data && !r.data.erro) ? r.data : null }).catch(() => {})
        },
        carregarQuadro () {
            this.statusQuadro = false
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/quadro-horario/getPorTurma/${this.turmaId}/${this.periodoId}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) {
                    window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' })
                    this.quadro = null
                } else {
                    this.quadro = r.data
                }
                this.statusQuadro = true
            }).catch(e => this.$store.commit('throwException', e))
        },
        /**
         * Usa o mecanismo de impressão que já existe no layout (`eventBus 'print'`), o
         * mesmo de todos os outros relatórios. Nenhuma biblioteca nova.
         *
         * A rota é `api/quadro-horario/imprimir` — e não `api/pdf/...` — porque a matriz
         * de permissão do Bloco F vive neste prefixo.
         */
        imprimir () {
            window.eventBus.$emit('print', {
                url: `/api/quadro-horario/imprimir/${this.turmaId}/${this.periodoId}`,
                param: null
            })
        },
        slotsDe (dia, ordem) {
            return this.slots.filter(s => parseInt(s.dia_semana) === parseInt(dia) && parseInt(s.ordem_aula) === parseInt(ordem))
        },
        removerSlot (id) {
            this.$confirm('Remover esta aula do quadro?', 'Confirmação', {
                confirmButtonText: 'Remover', cancelButtonText: 'Cancelar', type: 'warning'
            }).then(() => {
                this.$axios.delete(
                    `${this.$store.state.config.baseUrlApi}/api/quadro-horario/removerSlot/${id}`,
                    this.$store.getters.getHeaderAuth
                ).then(r => {
                    if (r.data && r.data.erro) {
                        window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' })
                        return
                    }
                    window.eventBus.$emit('alert', { msg: 'Aula removida.', type: 'success' })
                    this.carregarQuadro()
                }).catch(e => this.$store.commit('throwException', e))
            }).catch(() => {})
        },

        // ---------------- geração ----------------
        gerarPrevia () {
            window.eventBus.$emit('loading', true)
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/gerador-quadro/gerar/${this.turmaId}/${this.periodoId}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                window.eventBus.$emit('loading', false)
                if (r.data && r.data.erro) {
                    window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' })
                    this.previa = null
                    return
                }
                this.previa = r.data
            }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
        },
        aplicar () {
            this.$confirm('Aplicar o quadro proposto para esta turma?', 'Confirmação', {
                confirmButtonText: 'Aplicar', cancelButtonText: 'Cancelar', type: 'warning'
            }).then(() => {
                window.eventBus.$emit('loading', true)
                // Somente ids: a proposta é recalculada no servidor.
                this.$axios.post(
                    `${this.$store.state.config.baseUrlApi}/api/gerador-quadro/aplicar`,
                    { turma_ids: [this.turmaId], periodo_letivo_id: this.periodoId, confirmar: true },
                    this.$store.getters.getHeaderAuth
                ).then(r => {
                    window.eventBus.$emit('loading', false)
                    if (r.data && r.data.erro) {
                        window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' })
                        return
                    }
                    if (!r.data.aplicadas) {
                        const ign = (r.data.ignoradas && r.data.ignoradas.length) ? r.data.ignoradas[0].motivo : 'Nenhuma turma aplicada.'
                        window.eventBus.$emit('alert', { msg: ign, type: 'warning' })
                        return
                    }
                    window.eventBus.$emit('alert', { msg: 'Quadro aplicado.', type: 'success' })
                    this.previa = null
                    this.aba = 'grade'
                    this.carregarQuadro()
                }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
            }).catch(() => {})
        },
        rotuloStatus (s) {
            const r = { totalmente_geravel: 'Turma totalmente gerável', parcialmente_geravel: 'Turma parcialmente gerável', nao_geravel: 'Turma não gerável' }
            return r[s] || s
        },
        tipoStatus (s) { return s === 'totalmente_geravel' ? 'success' : (s === 'parcialmente_geravel' ? 'warning' : 'error') },

        // ---------------- conflitos ----------------
        diagnosticarConflitos () {
            window.eventBus.$emit('loading', true)
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/conflito-quadro/diagnosticarQuadro/${this.turmaId}/${this.periodoId}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                window.eventBus.$emit('loading', false)
                if (r.data && r.data.erro) {
                    window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' })
                    return
                }
                this.conflitos = r.data
            }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
        },

        // ---------------- dependências ----------------
        carregarDependencias () {
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/dependencia-turma/getPorTurma/${this.turmaId}`,
                this.$store.getters.getHeaderAuth
            ).then(r => { this.dependencias = (r.data && r.data.itens) ? r.data.itens : [] }).catch(() => {})

            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/dependencia-turma/initForm/${this.turmaId}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                // Se o backend usou a infraestrutura de outro período, o aviso dele é exibido.
                this.depInit = (r.data && !r.data.erro) ? r.data : null
                if (r.data && r.data.erro) window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' })
            }).catch(() => {})
        },
        salvarDependencia () {
            this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/dependencia-turma/store`,
                Object.assign({ turma_id: this.turmaId }, this.novaDep),
                this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) {
                    window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' })
                    return
                }
                window.eventBus.$emit('alert', { msg: 'Dependência vinculada.', type: 'success' })
                this.novaDep = { dependencia_instituicao_id: null, finalidade: '', principal: false }
                this.carregarDependencias()
            }).catch(e => this.$store.commit('throwException', e))
        },
        excluirDependencia (id) {
            this.$axios.delete(
                `${this.$store.state.config.baseUrlApi}/api/dependencia-turma/delete/${id}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) {
                    window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' })
                    return
                }
                window.eventBus.$emit('alert', { msg: 'Vínculo removido.', type: 'success' })
                this.carregarDependencias()
            }).catch(e => this.$store.commit('throwException', e))
        },

        // ---------------- divisões ----------------
        carregarDivisoes () {
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/componente-divisao/getPorTurma/${this.turmaId}`,
                this.$store.getters.getHeaderAuth
            ).then(r => { this.divisoes = (r.data && r.data.divisoes) ? r.data.divisoes : [] }).catch(() => {})
        },
        abrirNovaDivisao () {
            this.novaDivisao = { area_conhecimento_id: null, nome: '', servidor_id: null, qtd_max_alunos: '' }
            this.professoresValidos = []
            this.avisoProfessores = null
            if (!this.areas.length) {
                this.$axios.get(
                    `${this.$store.state.config.baseUrlApi}/api/area-conhecimento/getAll`,
                    this.$store.getters.getHeaderAuth
                ).then(r => { this.areas = Array.isArray(r.data) ? r.data : [] }).catch(() => {})
            }
            this.dialogoDivisao = true
        },
        carregarProfessoresValidos () {
            this.professoresValidos = []
            this.avisoProfessores = null
            this.novaDivisao.servidor_id = null
            if (!this.novaDivisao.area_conhecimento_id) return
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/componente-divisao/professoresValidos/${this.turmaId}/${this.novaDivisao.area_conhecimento_id}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) { this.avisoProfessores = this.textoErro(r.data.erro); return }
                this.professoresValidos = r.data.servidores || []
                this.avisoProfessores = r.data.aviso || null
            }).catch(() => {})
        },
        salvarDivisao () {
            this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/componente-divisao/store`,
                Object.assign({ turma_id: this.turmaId }, this.novaDivisao),
                this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) {
                    window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' })
                    return
                }
                window.eventBus.$emit('alert', { msg: 'Divisão criada.', type: 'success' })
                this.dialogoDivisao = false
                this.carregarDivisoes()
            }).catch(e => this.$store.commit('throwException', e))
        },
        excluirDivisao (id) {
            this.$confirm('Excluir esta divisão?', 'Confirmação', {
                confirmButtonText: 'Excluir', cancelButtonText: 'Cancelar', type: 'warning'
            }).then(() => {
                this.$axios.delete(
                    `${this.$store.state.config.baseUrlApi}/api/componente-divisao/delete/${id}`,
                    this.$store.getters.getHeaderAuth
                ).then(r => {
                    if (r.data && r.data.erro) {
                        window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' })
                        return
                    }
                    window.eventBus.$emit('alert', { msg: 'Divisão removida.', type: 'success' })
                    this.carregarDivisoes()
                }).catch(e => this.$store.commit('throwException', e))
            }).catch(() => {})
        },
        abrirAlunos (divisao) {
            this.divisaoAtual = divisao
            this.alunosOpcoes = []
            this.alunosSelecionados = []

            // Já vinculados a esta divisão.
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/componente-divisao/getById/${divisao.id}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                const atuais = (r.data && r.data.alunos) ? r.data.alunos : []
                atuais.forEach(a => {
                    this.alunosOpcoes.push({ key: a.matricula_id, label: a.nome_aluno })
                    this.alunosSelecionados.push(a.matricula_id)
                })

                // Disponíveis: a API já exclui quem está em divisão irmã do mesmo componente.
                return this.$axios.get(
                    `${this.$store.state.config.baseUrlApi}/api/componente-divisao/alunosDisponiveis/${divisao.id}`,
                    this.$store.getters.getHeaderAuth
                )
            }).then(r => {
                if (!r) return
                const disp = Array.isArray(r.data) ? r.data : []
                disp.forEach(a => {
                    if (!this.alunosOpcoes.some(o => o.key === a.matricula_id)) {
                        this.alunosOpcoes.push({ key: a.matricula_id, label: a.nome_aluno })
                    }
                })
                this.dialogoAlunos = true
            }).catch(e => this.$store.commit('throwException', e))
        },
        salvarAlunos () {
            this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/componente-divisao/salvarAlunos/${this.divisaoAtual.id}`,
                { matricula_ids: this.alunosSelecionados },
                this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) {
                    // Ex.: "O aluno X já está na divisão Grupo A deste mesmo componente."
                    window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' })
                    return
                }
                window.eventBus.$emit('alert', { msg: 'Alunos da divisão salvos.', type: 'success' })
                this.dialogoAlunos = false
                this.carregarDivisoes()
            }).catch(e => this.$store.commit('throwException', e))
        },

        textoErro (erro) { return typeof erro === 'string' ? erro : (erro.text || 'Não foi possível concluir.') }
    }
}
</script>
